import Text from "components/ui/Text";
import * as style from "./Title.styles";
import Close from "static-file/images/close.png";

interface Props {
  title: string;
  subTitle?: string;
}

export const NaverTitle = ({ title, subTitle }: Props) => {
  return (
    <style.Container>
      <Text fontSize={24} fontWeight={600} color="#3F3F46" lineHeight={120}>{title}</Text>
      {subTitle && <Text fontSize={14} fontWeight={400} color="#51525C">{subTitle}</Text>}
    </style.Container>
  );
};
